import React, {useCallback, useEffect} from 'react'
import View from './view'
import {Divisions} from '../../../../constants/divisions'
import {useSelector} from 'react-redux'
import {
  getReportedExamResults,
  selectNcarbAttempts,
} from '../../../../redux/reportExamStatus'
import {useAppDispatch} from '../../../../redux/configureStore'
import {useAuth} from '../../../../components/AuthProvider'

type Props = {
  division: Divisions
}

const ProgressCard = ({division}: Props) => {
  const dispatch = useAppDispatch()
  const auth = useAuth()
  const examReports = useSelector(selectNcarbAttempts)

  const loadExamReports = useCallback(async () => {
    await dispatch(getReportedExamResults({auth}))
  }, [dispatch, auth.isAuthenticated])

  useEffect(() => {
    if (auth.isAuthenticated) {
      loadExamReports()
    }
  }, [loadExamReports])

  return <View division={division} examReports={examReports} />
}

export default ProgressCard
